import axios from 'axios';

export default {
	getConfigs(){
		return axios.get('/api/v1/settings/get-configs');
	},
	getMenuNavigation(){
		return axios.get('/api/v1/site/get-menu-navigation');
	},	
}